import { render, staticRenderFns } from "./orderRecord.vue?vue&type=template&id=4c72010c&scoped=true&"
import script from "./orderRecord.vue?vue&type=script&lang=js&"
export * from "./orderRecord.vue?vue&type=script&lang=js&"
import style0 from "./orderRecord.vue?vue&type=style&index=0&id=4c72010c&scoped=true&lang=css&"
import style1 from "./orderRecord.vue?vue&type=style&index=1&lang=css&"
import style2 from "./orderRecord.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c72010c",
  null
  
)

export default component.exports